var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysiciansRevenue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.82,
    height: 46.46,
    viewBox: "0 0 95.82 46.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.18,46.26,18.8,29.57a2.46,2.46,0,0,1,3.32-.13l5.49,4.3a2.49,2.49,0,0,0,3.47-.28l18.37-18.6a2.48,2.48,0,0,1,3.25-.43l14.08,9.21a2.45,2.45,0,0,0,3.15-.34L94.66.2",
    fill: "none",
    stroke: "#d2c355",
    strokeMiterlimit: 10,
    strokeWidth: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,5.32,69.89,25.86a2.61,2.61,0,0,1-3.1.29L52.83,18a2.63,2.63,0,0,0-3.2.38L31,34.88a2.61,2.61,0,0,1-3.4.25L22.15,31.3a2.6,2.6,0,0,0-3.25.13L.18,46.26",
    fill: "none",
    stroke: "#beb150",
    strokeMiterlimit: 10,
    strokeWidth: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.92,10.44l-25.07,18a2.81,2.81,0,0,1-3,.26L53,21.5a2.82,2.82,0,0,0-3.14.34L31,36.31a2.83,2.83,0,0,1-3.35.21l-5.48-3.35a2.8,2.8,0,0,0-3.19.11L.18,46.26",
    fill: "none",
    stroke: "#aa9f4a",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.05,15.55,69.8,31a3.09,3.09,0,0,1-3,.22L53.09,25a3.12,3.12,0,0,0-3.09.29L31,37.73a3.11,3.11,0,0,1-3.29.18L22.21,35a3.08,3.08,0,0,0-3.13.09L.18,46.26",
    fill: "none",
    stroke: "#968d45",
    strokeMiterlimit: 10,
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.17,20.67,69.76,33.51a3.51,3.51,0,0,1-2.92.18L53.22,28.58a3.48,3.48,0,0,0-3,.24L31,39.15a3.57,3.57,0,0,1-3.24.16l-5.46-2.4a3.49,3.49,0,0,0-3.07.08l-19,9.27",
    fill: "none",
    stroke: "#827b40",
    strokeMiterlimit: 10,
    strokeWidth: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3,25.79,69.72,36.06a4.14,4.14,0,0,1-2.86.14L53.34,32.11a4.15,4.15,0,0,0-3,.19L30.92,40.57a4.17,4.17,0,0,1-3.18.13l-5.46-1.92a4.12,4.12,0,0,0-3,.06L.18,46.26",
    fill: "none",
    stroke: "#6d683a",
    strokeMiterlimit: 10,
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.43,30.9,69.68,38.61a5.22,5.22,0,0,1-2.8.11L53.47,35.65a5.24,5.24,0,0,0-2.91.14L30.89,42a5.27,5.27,0,0,1-3.12.1l-5.46-1.44a5.2,5.2,0,0,0-2.95,0L.18,46.26",
    fill: "none",
    stroke: "#595635",
    strokeMiterlimit: 10,
    strokeWidth: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.56,36,69.64,41.16a7.47,7.47,0,0,1-2.75.07l-13.29-2a7.59,7.59,0,0,0-2.85.1l-19.9,4.13a7.5,7.5,0,0,1-3.06.07l-5.44-1a7.4,7.4,0,0,0-2.89,0L.18,46.26",
    fill: "none",
    stroke: "#454430",
    strokeMiterlimit: 10,
    strokeWidth: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.69,41.14,69.6,43.71a14.22,14.22,0,0,1-2.69,0l-13.18-1a13.78,13.78,0,0,0-2.8.05L30.82,44.83a14.32,14.32,0,0,1-3,0l-5.44-.48a14.08,14.08,0,0,0-2.83,0L.18,46.26",
    fill: "none",
    stroke: "#31322a",
    strokeMiterlimit: 10,
    strokeWidth: 0.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.82,
    y1: 46.26,
    x2: 0.18,
    y2: 46.26,
    fill: "none",
    stroke: "#1d2025",
    strokeMiterlimit: 10,
    strokeWidth: 0.34
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiciansRevenue);
export default __webpack_public_path__ + "static/media/physiciansRevenue.49c73d7842532d9942ca3026eed2a481.svg";
export { ForwardRef as ReactComponent };